import {
    Card,
    Row,
    Col,
    ProgressBar,
    Spinner,
    Alert,
} from "react-bootstrap";
import { useRanks } from "./hooks/use-ranks";
import { getRankColor } from "../../utils/getRankColor";
import { getRankImage } from "../../utils/getRankImage";

const Rank = () => {
    const {
        isLoading,
        error,
        currentUserPoints,
        pointsToNextRankHistory,
        currentRank,
        nextRank,
        currentRankIndex,
        ranks
    } = useRanks();

    if (isLoading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" />
            </div>
        );
    }

    if (error || !ranks?.length) {
        return (
            <Alert variant="danger">
                No fue posible cargar los rangos.
            </Alert>
        );
    }



    const currentProgress = nextRank
        ? Math.min(
            100,
            (currentUserPoints / nextRank.points) * 100
        )
        : 100;





    return (<>
        <Row
            className="g-4 align-items-stretch"
            style={{ minHeight: "500px" }}
        >

            <Col xl={3} className="d-flex order-1 order-xl-1">
                <Card.Body className="p-4 rounded-4 w-100"
                    style={{
                        background: "#101010",
                        color: "#fff",
                    }}
                >
                    <h5
                        className="fw-bold mb-4 text-white"
                        style={{
                            fontSize: "24px",
                        }}
                    >
                        Mi Rango Actual
                    </h5>

                    <div className="d-flex align-items-center mb-4">
                        <div
                            className="d-flex align-items-center justify-content-center me-3"
                            style={{
                                width: 85,
                                height: 85
                            }}
                        >
                            <img
                                src={getRankImage(currentRank?.user_data?.rank.name || '')}
                                alt={currentRank?.user_data?.rank.name || ''}
                                style={{
                                    width: 80,
                                    height: 80,
                                    objectFit: "contain",
                                    filter: `drop-shadow(0 0 10px ${getRankColor(currentRank?.user_data?.rank.name)})`
                                }}
                            />
                        </div>

                        <div>
                            <h2
                                className="fw-bold mb-1"
                                style={{
                                    color: getRankColor(currentRank?.user_data?.rank.name),
                                    fontSize: "30px",
                                }}
                            >
                                {currentRank?.user_data?.rank.name}
                            </h2>

                            <span
                                className="px-3 py-1 rounded-pill fw-semibold"
                                style={{
                                    background: "rgba(67,209,49,.15)",
                                    color: getRankColor(currentRank?.user_data?.rank.name),
                                    border: "1px solid rgba(67,209,49,.25)",
                                    fontSize: "11px",
                                }}
                            >
                                Rango máximo alcanzado
                            </span>
                            <div
                                className="align-items-center mt-2"
                                style={{
                                    color: "#8B949E",
                                    fontSize: 14,
                                }}
                            >
                                <i
                                    className="ri-calendar-line me-2"
                                    style={{
                                        color: getRankColor(currentRank?.user_data?.rank.name),
                                        fontSize: 16,
                                    }}
                                /> fecha alcanzada:
                                <br />
                                <span className="fw-bold text-white" style={{ fontSize: 16 }}>
                                    {currentRank?.period?.end
                                        ? new Date(currentRank.period.end).toLocaleDateString()
                                        : "Fecha no disponible"}
                                </span>
                            </div>
                        </div>

                    </div>



                    <div
                        className="d-flex align-items-start py-3"
                        style={{
                            borderBottom: "1px solid rgba(255,255,255,.06)",
                        }}
                    >
                        <i
                            className="ri-flashlight-line me-3"
                            style={{
                                color: "#D9A441",
                                fontSize: 22,
                            }}
                        />

                        <div>
                            <div
                                style={{
                                    color: "#8B949E",
                                    fontSize: 13,
                                }}
                            >
                                Puntos para alcanzar
                            </div>

                            <div
                                className="fw-bold text-white"
                                style={{
                                    fontSize: 18,
                                }}
                            >
                                {currentRank?.user_data?.rank.points_required?.toLocaleString()} pts
                            </div>
                        </div>
                    </div>

                    <div
                        className="d-flex align-items-start py-3"
                        style={{
                            borderBottom: "1px solid rgba(255,255,255,.06)",
                        }}
                    >
                        <i
                            className="ri-bar-chart-grouped-line me-3"
                            style={{
                                color: "#D9A441",
                                fontSize: 22,
                            }}
                        />

                        <div>
                            <div
                                style={{
                                    color: "#8B949E",
                                    fontSize: 13,
                                }}
                            >
                                Puntos al alcanzarlo
                            </div>

                            <div
                                className="fw-bold"
                                style={{
                                    color: getRankColor(currentRank?.user_data?.rank.name),
                                    fontSize: 28,
                                }}
                            >
                                {currentRank?.user_data?.total_points?.toLocaleString()} pts
                            </div>
                        </div>
                    </div>

                    <div
                        className="d-flex align-items-start py-3"
                        style={{
                            borderBottom: "1px solid rgba(255,255,255,.06)",
                        }}
                    >
                        <i
                            className="ri-award-line me-3"
                            style={{
                                color: "#D9A441",
                                fontSize: 22,
                            }}
                        />

                        <div>
                            <div
                                style={{
                                    color: "#8B949E",
                                    fontSize: 13,
                                }}
                            >
                                Puntos actuales
                            </div>

                            <div
                                className="fw-bold text-white"
                                style={{
                                    fontSize: 18,
                                }}
                            >
                                {currentUserPoints.toLocaleString()} pts
                            </div>
                        </div>
                    </div>


                    {nextRank && (
                        <div className="pt-3">
                            <div className="d-flex align-items-start">
                                <i
                                    className="ri-trophy-line me-3"
                                    style={{
                                        color: "#D9A441",
                                        fontSize: 22,
                                    }}
                                />

                                <div>
                                    <div
                                        style={{
                                            color: "#8B949E",
                                            fontSize: 13,
                                        }}
                                    >
                                        Siguiente rango
                                    </div>

                                    <div
                                        className="fw-bold"
                                        style={{
                                            color: getRankColor(nextRank?.name),
                                            fontSize: 28,
                                            lineHeight: 1.1,
                                        }}
                                    >
                                        {nextRank.name}
                                    </div>

                                    <small
                                        style={{
                                            color: "#DADADA",
                                            fontSize: 14,
                                        }}
                                    >
                                        Requiere {nextRank?.points?.toLocaleString()} pts
                                    </small>
                                </div>
                            </div>
                        </div>
                    )}
                </Card.Body>
            </Col>


            <Col xl={9} className="d-flex order-3 order-xl-2">
                <Card.Body className="p-4 rounded-4 h-100 w-100 d-flex flex-column"
                    style={{
                        background: "#101010",
                        color: "#fff",
                    }}>
                    <h4
                        className="fw-bold mb-4"
                        style={{
                            color: "#fff",
                            fontSize: "28px",
                        }}
                    >
                        Rango Histórico Alcanzado
                    </h4>

                    <div
                        className="d-none d-lg-grid mb-3 px-3"
                        style={{
                            gridTemplateColumns: "280px 160px 160px 160px 140px",
                            color: "#8B949E",
                            fontSize: "13px",
                        }}
                    >
                        <div>Rango</div>
                        <div>Fecha alcanzada</div>
                        <div>Puntos requeridos</div>
                        <div>Puntos alcanzados</div>
                        <div>Estado</div>
                    </div>

                    <div className="position-relative">

                        <div
                            style={{
                                position: "absolute",
                                left: "18px",
                                top: "20px",
                                bottom: "20px",
                                width: "2px",
                                background:
                                    "linear-gradient(to bottom, rgba(255,255,255,.25), rgba(255,255,255,.05))",
                            }}
                        />

                        <div
                            className="flex-grow-1 pe-2 custom-scroll"
                            style={{
                                overflowY: "auto",
                                maxHeight: "500px",
                            }}
                        >
                            <div className="position-relative">

                                <div
                                    style={{
                                        position: "absolute",
                                        left: "18px",
                                        top: "20px",
                                        bottom: "20px",
                                        width: "2px",
                                        background:
                                            "linear-gradient(to bottom, rgba(255,255,255,.25), rgba(255,255,255,.05))",
                                    }}
                                />
                                {ranks.map((rank, index: number) => {

                                    const isCurrent = index === currentRankIndex;
                                    const isCompleted = rank.myRank;

                                    const color = getRankColor(rank?.name);

                                    return (
                                        <div
                                            key={rank.id}
                                            className="position-relative mb-2"
                                            style={{
                                                marginLeft: "35px",
                                                borderRadius: "14px",
                                                background: isCurrent
                                                    ? `linear-gradient(
                                                        90deg,
                                                        ${color}20 0%,
                                                        ${color}08 100%
                                                    )`
                                                    : "rgba(255,255,255,.02)",

                                                border: isCurrent
                                                    ? `1px solid ${color}70`
                                                    : "1px solid rgba(255,255,255,.06)",

                                                boxShadow:
                                                    isCompleted && isCurrent
                                                        ? `0 0 30px ${color}30`
                                                        : "none",
                                            }}
                                        >

                                            <div
                                                style={{
                                                    position: "absolute",
                                                    left: "-27px",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    width: "18px",
                                                    height: "18px",
                                                    borderRadius: "50%",

                                                    background: isCompleted
                                                        ? color
                                                        : "#6B7280",

                                                    border: "2px solid #4B5563",
                                                    opacity: isCompleted ? 1 : 0.6,
                                                }}
                                            />

                                            <div
                                                className="d-grid align-items-center p-3"
                                                style={{
                                                    gridTemplateColumns:
                                                        "280px 160px 160px 160px 140px",
                                                }}
                                            >
                                                {/* Rango */}
                                                <div className="d-flex align-items-center">
                                                    <div
                                                        className="d-flex align-items-center justify-content-center me-3"
                                                        style={{
                                                            width: 48,
                                                            height: 48,
                                                            borderRadius: "50%",
                                                            background: `${color}20`,
                                                            border: `1px solid ${color}50`,
                                                        }}
                                                    >
                                                        <img
                                                            src={getRankImage(rank?.name || '')}
                                                            alt={rank?.name || ''}
                                                            style={{
                                                                width: 80,
                                                                height: 80,
                                                                objectFit: "contain",
                                                                opacity: isCompleted ? 1 : 0.4,
                                                                filter: isCompleted
                                                                    ? `drop-shadow(0 0 10px ${color})`
                                                                    : "grayscale(100%) opacity(0.5)",
                                                                transition: "all .3s ease",
                                                            }}
                                                        />
                                                    </div>

                                                    <div>
                                                        <div
                                                            className="fw-semibold"
                                                            style={{
                                                                color: "#fff",
                                                            }}
                                                        >
                                                            {rank?.name}
                                                        </div>

                                                        <div
                                                            style={{
                                                                color: "#8B949E",
                                                                fontSize: "13px",
                                                            }}
                                                        >

                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Fecha */}

                                                <div
                                                    className="d-flex align-items-center"
                                                    style={{
                                                        color: "#E5E7EB",
                                                    }}
                                                >
                                                    {rank.myRank && <i className="ri-calendar-line me-2" />}

                                                    {rank?.myRank ? new Date(rank.myRank.period.end ?? "").toLocaleDateString("es-CO") : '-'}
                                                </div>

                                                {/* Requeridos */}
                                                <div
                                                    style={{
                                                        color: "#E5E7EB",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {rank?.points?.toLocaleString()} pts
                                                </div>

                                                {/* Alcanzados */}
                                                <div
                                                    style={{
                                                        color: "#E5E7EB",
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    {rank?.myRank ? rank?.myRank.user_data.total_points?.toLocaleString() + ' pts' : '-'}
                                                </div>

                                                <div>
                                                    <span
                                                        className="px-3 py-2"
                                                        style={{
                                                            display: "inline-block",
                                                            borderRadius: "10px",
                                                            fontSize: "13px",
                                                            fontWeight: 600,
                                                            background: isCompleted || isCurrent
                                                                ? "rgba(67,209,49,.08)"
                                                                : "rgba(255,255,255,.05)",
                                                            border:
                                                                isCompleted || isCurrent
                                                                    ? "1px solid rgba(67,209,49,.15)"
                                                                    : "1px solid rgba(255,255,255,.08)",
                                                            color:
                                                                isCompleted || isCurrent
                                                                    ? "#65E255"
                                                                    : "#A1A1AA",
                                                        }}
                                                    >
                                                        {isCompleted || isCurrent
                                                            ? "Completado"
                                                            : "Pendiente"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>


                    </div>

                    <Row className="mt-4 pt-3 border-top border-secondary border-opacity-25 g-4">
                        <Col md={6}>
                            <div
                                className="d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start"
                                style={{
                                    gap: "10px",
                                }}
                            >
                                <i
                                    className="ri-information-line"
                                    style={{
                                        color: "#CFCFCF",
                                        fontSize: 22,
                                        flexShrink: 0,
                                    }}
                                />
                                <small
                                    style={{
                                        color: "#8B949E",
                                        lineHeight: 1.6,
                                        maxWidth: "350px",
                                    }}
                                >
                                    Los rangos se calculan acumulando puntos o volumen en toda tu red.
                                </small>
                            </div>
                        </Col>

                        <Col md={6}>
                            <div
                                className="d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start"
                                style={{
                                    gap: "10px",
                                }}
                            >
                                <i
                                    className="ri-bar-chart-box-line"
                                    style={{
                                        color: "#fff",
                                        fontSize: 22,
                                        flexShrink: 0,
                                    }}
                                />

                                <small
                                    style={{
                                        color: "#8B949E",
                                        lineHeight: 1.6,
                                        maxWidth: "350px",
                                    }}
                                >
                                    La fecha y los puntos corresponden a la primera vez que alcanzaste cada rango; no cambian con las recalificaciones de meses posteriores.
                                </small>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Col>


            {nextRank && (
                <Col xs={12} className="order-2 order-xl-3">
                    <Card
                        className="border-0 rounded-4 mt-4 mb-4"
                        style={{
                            background: "#0B1118",
                            color: "#fff",
                            boxShadow: "0 0 0 1px rgba(255,255,255,.05)",
                        }}
                    >
                        <Card.Body className="p-4">
                            <h5 className="fw-bold mb-4">
                                Próximo Rango a Alcanzar
                            </h5>

                            <Row className="align-items-center">
                                {/* RANGO */}
                                <Col
                                    lg={4}
                                    className="pe-lg-4 mb-4 mb-lg-0"
                                    style={{
                                        borderRight: "1px solid rgba(255,255,255,.08)",
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{
                                                width: 90,
                                                height: 90,
                                            }}
                                        >
                                            <img
                                                src={getRankImage(nextRank?.name)}
                                                alt={nextRank?.name || ''}
                                                style={{
                                                    width: 80,
                                                    height: 80,
                                                    objectFit: "contain",
                                                    filter: `drop-shadow(0 0 10px ${getRankColor(nextRank?.name || '')})`
                                                }}
                                            />
                                        </div>

                                        <div className="ms-3">
                                            <h3
                                                className="fw-bold mb-2"
                                                style={{
                                                    color: getRankColor(nextRank?.name || ''),
                                                }}
                                            >
                                                {nextRank?.name}
                                            </h3>

                                            <span
                                                className="px-3 py-1 rounded-pill"
                                                style={{
                                                    background: "rgba(77,141,255,.15)",
                                                    color: "#A7C7FF",
                                                    fontSize: 12,
                                                    fontWeight: 600,
                                                }}
                                            >
                                                Siguiente objetivo
                                            </span>

                                            <div
                                                className="mt-3"
                                                style={{
                                                    color: "#C7CDD4",
                                                }}
                                            >
                                                Requiere{" "}
                                                {nextRank?.points?.toLocaleString()} pts
                                            </div>
                                        </div>
                                    </div>
                                </Col>


                                <Col
                                    lg={3}
                                    className="px-lg-4 mb-4 mb-lg-0"
                                    style={{
                                        borderRight: "1px solid rgba(255,255,255,.08)",
                                    }}
                                >
                                    <small
                                        style={{
                                            color: "#8B949E",
                                            display: "block",
                                            marginBottom: 10,
                                        }}
                                    >
                                        Te faltan
                                    </small>

                                    <h2
                                        className="fw-bold mb-2"
                                        style={{
                                            color: getRankColor(nextRank?.name || ''),
                                            fontSize: "2rem",
                                        }}
                                    >
                                        {pointsToNextRankHistory.toLocaleString()} pts
                                    </h2>

                                    <div
                                        style={{
                                            color: "#A0A8B3",
                                            fontSize: 14,
                                            lineHeight: 1.4,
                                        }}
                                    >
                                        para alcanzar el rango
                                    </div>

                                    <div
                                        className="fw-semibold"
                                        style={{
                                            color: "#FFFFFF",
                                        }}
                                    >

                                        {nextRank?.name?.toLocaleString()}
                                    </div>
                                </Col>

                                {/* PROGRESO */}
                                <Col lg={5} className="ps-lg-4">
                                    <div className="fw-semibold mb-3">
                                        Progreso hacia el siguiente rango
                                    </div>

                                    <ProgressBar
                                        now={currentProgress}
                                        style={{
                                            height: 8,
                                            backgroundColor: "#2B2D2E",
                                            borderRadius: 999,
                                        }}
                                    />

                                    <div className="d-flex justify-content-between mt-3">
                                        <div>
                                            <div
                                                className="fw-semibold"
                                                style={{
                                                    color: "#FFFFFF",
                                                }}
                                            >


                                                {currentUserPoints.toLocaleString()} pts
                                            </div>
                                        </div>

                                        <div className="text-end">
                                            <div
                                                className="fw-semibold"
                                                style={{
                                                    color: "#FFFFFF",
                                                }}
                                            >
                                                {nextRank?.points?.toLocaleString()} pts
                                            </div>

                                            <small
                                                style={{
                                                    color: "#8B949E",
                                                }}
                                            >
                                                Meta
                                            </small>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            )}
        </Row>
    </>)
};

export default Rank;